import { Outlet, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { SidebarProvider } from "@/components/ui/sidebar";
import AppSidebar from "@/components/AppSidebar";
import ReconnectBanner from "@/components/ReconnectBanner";
import { shouldShowConsoleNavigation, isExpiredSubscriptionStatus, isAdminUser } from "@/lib/route-access";

export default function AppShell() {
  const { user, loading, agencyContext } = useAuth();

  if (loading) {
    return (
      <div className="flex h-[100dvh] items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  const showNavigation = shouldShowConsoleNavigation(agencyContext?.subscription_status);
  const isExpired = isExpiredSubscriptionStatus(agencyContext?.subscription_status) && !isAdminUser(agencyContext?.user_role);

  return (
    <SidebarProvider>
      <div className="flex h-[100dvh] w-full overflow-hidden bg-background">
        {showNavigation && (
          <>
            <a
              href="#main-content"
              className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:ring-2 focus:ring-ring"
            >
              Skip to main content
            </a>
            <AppSidebar />
          </>
        )}
        <div className="flex flex-col flex-1 overflow-hidden">
          {isExpired && (
            <div className="flex items-center justify-center gap-3 bg-destructive/10 border-b border-destructive/20 px-4 py-2 text-sm text-destructive">
              <span className="font-medium">Account expired — upgrade to continue.</span>
              <Link
                to="/account?tab=billing"
                className="rounded-md bg-destructive px-3 py-1 text-xs font-semibold text-destructive-foreground hover:bg-destructive/90 transition-colors"
              >
                Upgrade
              </Link>
            </div>
          )}
          {showNavigation && !isExpired && <ReconnectBanner />}
          <main id="main-content" className="flex-1 overflow-y-auto scrollbar-thin">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
